import {ChartType, ResourceType} from 'common/report/constants';
import {FilterClause} from 'common/report/insights/models/clause';
import {getEventValueAndLabel} from 'common/report/util/events';
import {ShowClause} from 'common/report/insights/util/types';
import {assert} from 'common/util';
import {assertUnreachable} from 'common/util/typescript';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {FiltersOperator, QueryEventEntry} from 'common/query-builder/query-entry-section/types';
import {FilterDeterminer} from 'common/report/insights/util/filters';
import {TrackName as DataTableTrackName} from 'common/components/data-table/types';

function determinerToFiltersOperator(determiner: FilterDeterminer) {
  if (!determiner) {
    return null;
  }
  switch (determiner) {
    case `any`:
      return FiltersOperator.Or;
    case `all`:
      return FiltersOperator.And;
    default:
      assertUnreachable(determiner);
  }
}

export function convertSegmentForEventsInspector(showClauses: ShowClause[]): QueryEventEntry[] {
  return showClauses.map((showClause) => {
    const showClauseFilters = showClause.filter || [];
    const determiner = showClauseFilters.find((filter: FilterClause) => filter.determiner)?.determiner;
    const filters: PropertyFilter[] = showClauseFilters.map(
      (filter: FilterClause): PropertyFilter => {
        return filter.propertyFilter;
      },
    );
    const {custom, name, id} = showClause.value;
    assert(!Array.isArray(name));
    const {label, value} = getEventValueAndLabel({name, custom, id});
    const queryEventEntry: QueryEventEntry = {
      type: ResourceType.Event,
      dataGroupId: showClause.dataGroupId,
      event: {
        label,
        value,
        custom,
        id,
      },
      filters,
      filtersOperator: determinerToFiltersOperator(determiner),
    };
    return queryEventEntry;
  });
}

export function hasDataTable(chartType: ChartType) {
  return [ChartType.Line, ChartType.Metric, ChartType.Pie].includes(chartType);
}

export function getDataTableTrackName(chartType: ChartType) {
  switch (chartType) {
    case ChartType.Line:
      return DataTableTrackName.InsightsLine;
    case ChartType.Metric:
      return DataTableTrackName.InsightsMetric;
    case ChartType.Pie:
      return DataTableTrackName.InsightsPie;
    default:
      throw new Error(`Data table not supported for ${chartType}`);
  }
}
